import type { PathTurnStepCollection } from "./PathTurnStepCollection.type"

/**
 * Inserts a PathTurnStepCollection into a queue at the correct position based on total cost.
 * This ensures that shorter paths are explored first, which can improve performance.
 * 
 * note that queue length typically is in the range of
 * 0-32
 */
export default function insertAtSortedByTotalCostIndex(
  queue: Array<PathTurnStepCollection>,
  item: PathTurnStepCollection
) {
  // Version 1 (inefficient, but correct)
  // queue.push(item)
  // queue.sort(byTotalCostAsc)
  // return

  // Version 2 (more efficient, but harder to read)
  // saved 200ms
  // const index = queue.findIndex((item) => item.totalCost > item.totalCost)
  // queue.splice(index, 0, item)

  // Version 3 (most efficient, but hardest to read)
  // saved another 200ms
  let low = 0
  let high = queue.length
  const { totalCost } = item
  
  while (low < high) {
    const mid = (low + high) >>> 1
    if (queue[mid].totalCost <= totalCost) {
      low = mid + 1
    } else {
      high = mid
    }
  }
  queue.splice(low, 0, item)

  // Version 4 (efficient, but no improvement)
  // for (let i = queue.length - 1; i >= 0; i--) {
  //   if (queue[i].totalCost >= item.totalCost) {
  //     queue.splice(i, 0, item)
  //     return
  //   }
  // }
  // queue.push(item)
}